import * as React from 'react';
import { connect } from 'react-redux';
import * as  apiService from '../../store/apiService'

// logout
import { logout } from '../../store/login/action'

// header
import Header from '../../sharedcomponents/header';

// loading
import { Loader } from '../../sharedcomponents/loader';


// actions
import { fetchAll41ProjectsReports } from '../../store/all41Projects/actions'
import { sortNumber, sortString} from '../../helpers/sortingHelper';

// devextremene grid
import {
  SearchState,
  FilteringState,
  IntegratedFiltering,
  PagingState,
  SortingState,
  CustomPaging,
  IntegratedPaging,
  IntegratedSorting,
  EditingState
} from '@devexpress/dx-react-grid';
import Paper from '@material-ui/core/Paper';
import {
  Grid,
  Table,
  Toolbar,
  SearchPanel,
  TableHeaderRow,
  TableFilterRow,
  PagingPanel,
  TableColumnVisibility,
  ColumnChooser,
} from '@devexpress/dx-react-grid-material-ui';

// @ts-ignore
const ColumnCell = ({ getMessage, column, ...restProps }) => (
  // @ts-ignore
  <TableHeaderRow.Cell
    column={column}
    getMessage={() => column.title}
    {...restProps}
  />
);

// @ts-ignore
const Cell = ({value, ...restProps}) => {
  const { column } = restProps;
  if (column.name === 'prop_num') {
    const propNum: number = parseInt(restProps.row.prop_num, 10);
    return <td className="text-center"><div><a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(propNum)}><i className="fa fa-trash-alt"></i>{propNum}</a></div></td>
  }
  if (column.name === 'ts_live') {
    if (restProps.row.ts_live === 'true') {
      return <td className="text-center"><div>TS LIVE</div></td>
    } else {
      return <td><div></div></td>
    }
  }
  if (column.name === 'static') {
    if (restProps.row.static === 'true') {
      return <td className="text-center"><div>STATIC</div></td>
    } else {
      return <td><div></div></td>
    }
  }
  if (column.name === 'custom_style') {
    if (restProps.row.custom_style === 'true') {
      return <td className="text-center"><div>CUSTOM STYLE</div></td>
    } else {
      return <td><div></div></td>
    }
  } 
  
  // @ts-ignore
  return <Table.Cell {...restProps} >
    <span title={value}>{value}</span>
  </Table.Cell>
};

function handleClickPropNum(args: any) {
  window.open(apiService.atlaslink(args), "_blank")
}

class all41Projects extends React.PureComponent<any, any>  {
  public changeCurrentPage: any; public changePageSize: any;
  constructor(props: any) {
    super(props);

    this.state = {
      route: '',
      date: '',
      columns: [
        { name: 'prop_num', title: 'PropNum' },
        { name: 'property_name', title: 'Property Name' },
        { name: 'ts_comments', title: 'Comments' },
        { name: 'template', title: 'Template' },
        { name: 'screen_resolution', title: 'Resolution' },
        { name: 'ts_live', title: 'TSLive?' },
        { name: 'static', title: 'Static?' },
        { name: 'custom_style', title: 'Custom?' },
        { name: 'zip_postal', title: 'Zip' }
      ],
      tableColumnExtensions: [
        { columnName: 'prop_num', align: 'center' },
        { columnName: 'property_name', align: 'left' },
        { columnName: 'ts_comments', align: 'left' },
        { columnName: 'template', align: 'center' },
        { columnName: 'screen_resolution', align: 'center' },
        { columnName: 'ts_live', align: 'center' },
        { columnName: 'static', align: 'center' },
        { columnName: 'custom_style', align: 'center' },
        { columnName: 'zip_postal', align: 'center' }
      ],
      rows: [],
      sorting: [{ columnName: 'prop_num', direction: 'asc' }],
      totalCount: 0,
      pageSize: 10,
      pageSizes: [10, 15, 30, 50],
      integratedSortingColumnExtensions: [
        { columnName: 'prop_num', compare: sortNumber },
        { columnName: 'property_name', compare: sortString },
        { columnName: 'ts_comments', compare: sortString }
      ],
      filteringColumnExtensions: [
        {
          columnName: 'ts_live',
          predicate: (value: any, filter: any, row: any) => {
            return this.filterNumber(value, filter, row);
          },
        }
      ],
    };

    this.changeSorting = this.changeSorting.bind(this);
    this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
    this.changePageSize = (pageSize: any) => this.setState({ pageSize });
    this.Sessionlogout = this.Sessionlogout.bind(this)
  }

  public componentDidMount() {
    this.props.dispatch(fetchAll41ProjectsReports());
  }

  // method to check the TS Live true or false
  public filterNumber(value: any, filter: any, row: any) {
    if (filter.columnName === 'ts_live' && filter.columnName === 'notContains') {
      const getFilterValue = (filter.value).toUpperCase();
      if ("TS LIVE".indexOf(getFilterValue) >= 0) {
        filter = {
          "columnName": "ts_live",
          "operation": "contains",
          "value": "true"
        }
      }
      else {
        filter = {
          "columnName": "ts_live",
          "operation": "contains",
          "value": "false"
        }
      }
      return IntegratedFiltering.defaultPredicate(value, filter, row);
    } else {
      return IntegratedFiltering.defaultPredicate(value, filter, row);
    }
  }

  public Sessionlogout() {
    this.props.dispatch(logout());
  }
 
  public componentDidUpdate() {
    if (this.props.AllReports) {
      this.setState({
        rows: this.props.AllReports
      })
    }
  }

  public commitChanges(deleted: any) {
    console.log(deleted);
    let { rows } = this.state;
    if (deleted) {
      const deletedSet = new Set(deleted);
      rows = rows.filter((row: any) => !deletedSet.has(row.id));
      console.log(rows);
    }
    this.setState({ rows });
  }

  public changeSorting(sorting: any) {
    this.setState({
      loading: true,
      sorting,
    });
  }

  public render() {
    const loading = this.props.loading ? <Loader /> : '';
    const {
      rows,
      columns,
      sorting,
      filteringColumnExtensions,
      integratedSortingColumnExtensions,
      tableColumnExtensions,
      pageSize,
      pageSizes,
      currentPage,
      totalCount
    } = this.state;

    return (

      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        <div className="content-body">
          <div className="content-section" id="all_41_Projects">
            <div className="grid-style">
              <Paper className="papergrid" style={{ position: 'relative' }}>
                <Grid
                  rows={rows}
                  columns={columns}
                >
                  <EditingState onCommitChanges={this.commitChanges} />
                  <SearchState defaultValue="" />
                  <FilteringState 
                  defaultFilters={[]}
                    columnExtensions={[
                      { columnName: 'ts_live', filteringEnabled: false },
                      { columnName: 'static', filteringEnabled: false },
                      { columnName: 'custom_style', filteringEnabled: false },
                    ]}
                  />
                  <IntegratedFiltering columnExtensions={filteringColumnExtensions} />

                  <SortingState
                    sorting={sorting}
                    onSortingChange={this.changeSorting}
                    defaultSorting={sorting}
                  />
                  <IntegratedSorting
                    columnExtensions={integratedSortingColumnExtensions}
                  />
                  <PagingState
                    defaultCurrentPage={0}
                    currentPage={currentPage}
                    onCurrentPageChange={this.changeCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={this.changePageSize}
                  />
                  <CustomPaging
                    totalCount={totalCount}
                  />
                  <IntegratedPaging />
                  <Table
                    columnExtensions={tableColumnExtensions}
                    cellComponent={Cell}
                  />
                  <TableHeaderRow
                    showSortingControls={true}
                    cellComponent={ColumnCell}
                  />
                  <TableFilterRow
                    showFilterSelector={false}

                  />
                  <TableColumnVisibility
                    defaultHiddenColumnNames={['']}
                  />
                  <Toolbar />
                  <SearchPanel />
                  <PagingPanel
                    pageSizes={pageSizes}
                  />
                  <ColumnChooser />
                </Grid>
              </Paper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// container
const mapStateToProps = (state: any) => ({
  AllReports: state.all41Projects.AllReports,
  loading: state.loading.getall41ProjectsStatus
});
export default connect(mapStateToProps)(all41Projects);


// WEBPACK FOOTER //
// ./src/components/All 4.1 Projects/all41Projects.tsx